import { createModalStore } from '@/shared/lib/modal';

export const useEditSoonModalStore = createModalStore();
